//
//
//
//
//

export default {
    data() {
        return {
            show: false
        };
    },
    mounted() {
        window.addEventListener('scroll', (eve) => {
            if (document.documentElement.scrollTop > window.screen.availHeight) {
                this.show = true;
            } else {
                this.show = false;
            }
        });
    }
};
